<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Breadcrumb</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Bootstrap design</h5>
              <p>Indicate the current page’s location within a navigational hierarchy that automatically adds separators
                via CSS.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item active" aria-current="page">Home</li>
                    </ol>
                  </nav>

                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="javascript:void(0);">Home</a></li>
                      <li class="breadcrumb-item active" aria-current="page">Library</li>
                    </ol>
                  </nav>

                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="javascript:void(0);">Home</a></li>
                      <li class="breadcrumb-item"><a href="javascript:void(0);">Library</a></li>
                      <li class="breadcrumb-item active" aria-current="page">Data</li>
                    </ol>
                  </nav>
                  <hr>
                  <pre><code class="language-html">&lt;nav aria-label=&quot;breadcrumb&quot;&gt;
      &lt;ol class=&quot;breadcrumb&quot;&gt;
          &lt;li class=&quot;breadcrumb-item active&quot; aria-current=&quot;page&quot;&gt;Home&lt;/li&gt;
      &lt;/ol&gt;
  &lt;/nav&gt;

  &lt;nav aria-label=&quot;breadcrumb&quot;&gt;
      &lt;ol class=&quot;breadcrumb&quot;&gt;
          &lt;li class=&quot;breadcrumb-item&quot;&gt;&lt;a href=&quot;javascript:void(0);&quot;&gt;Home&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;breadcrumb-item active&quot; aria-current=&quot;page&quot;&gt;Library&lt;/li&gt;
      &lt;/ol&gt;
  &lt;/nav&gt;

  &lt;nav aria-label=&quot;breadcrumb&quot;&gt;
      &lt;ol class=&quot;breadcrumb&quot;&gt;
          &lt;li class=&quot;breadcrumb-item&quot;&gt;&lt;a href=&quot;javascript:void(0);&quot;&gt;Home&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;breadcrumb-item&quot;&gt;&lt;a href=&quot;javascript:void(0);&quot;&gt;Library&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;breadcrumb-item active&quot; aria-current=&quot;page&quot;&gt;Data&lt;/li&gt;
      &lt;/ol&gt;
  &lt;/nav&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
